import { QueryFactory } from "../../../../Common";
import { Casino } from "../../../../Contracts";
export const QGetFreespins = QueryFactory(Casino.QueryTypes.GetFreespins);
//# sourceMappingURL=QGetFreespins.js.map